import { NAME } from './constants';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCH_NEXT: `${NAME}/FETCH_NEXT`,
  FETCH_PREV: `${NAME}/FETCH_PREV`,
  FETCHING: `${NAME}/FETCHING`,
  FETCHED: `${NAME}/FETCHED`,
  UPDATE_SHIPMENT: `${NAME}/UPDATE_SHIPMENT`,
  CANCEL: `${NAME}/CANCEL`,
  CANCELLED: `${NAME}/CANCELLED`,
  UPDATE_RECIPIENT: `${NAME}/UPDATE_RECIPIENT`,
  UPDATED_RECIPIENT: `${NAME}/UPDATED_RECIPIENT`,
  TOGGLE_UPDATE_RECIPIENT_SCREEN: `${NAME}/TOGGLE_UPDATE_RECIPIENT_SCREEN`,
};
